import axiosInstance from '../../utils/AxiosInstance'

import { INDEX, THREADS, ON_CHANGE } from './types'

import { reset, preloader } from '../Preloader/actions'

export const setIndex = (index) => ({ type: INDEX, index })

export const getThreads = () => {
  return (dispatch, getState) => {
    const { threads, threadLoaded } = getState().discussion

    axiosInstance.get('/topics').then((threads) => {
      if (Array.isArray(threads)) {
        dispatch({ type: THREADS, threads })
      }

      if (!threadLoaded) {
        dispatch(preloader())
      }
    })
  }
}

export const createThread = () => {
  return (dispatch, getState) => {
    const { first_name, last_name, job_title } = getState().users.user
    const { title, data, threads } = getState().discussion

    if (!title || !title.trim()) {
      alert('You can not save an empty topic!')
      return
    }

    axiosInstance
      .post('/topics', {
        title,
        content: JSON.stringify({
          data,
          user: {
            first_name,
            last_name,
            job_title,
          },
        }),
      })
      .then((thread) => {
        if (thread) {
          dispatch(getThreads())
        }
      })

    dispatch(onChange('title', ''))
    dispatch(onChange('data', ''))
  }
}

export const deleteThread = (index) => {
  return (dispatch, getState) => {
    const { threads } = getState().discussion
    const { id } = threads[index]
    let language = {}
    // eslint-disable-next-line no-unused-expressions
    getState().language.language
      ? (language = getState().language.language.data)
      : null

    if (
      // eslint-disable-next-line no-restricted-globals
      confirm(language.alerts ? language.alerts.delete_topic_confirm : null)
    ) {
      const updateThreads = [
        ...threads.slice(0, index),
        ...threads.slice(index + 1),
      ]

      dispatch({ type: THREADS, threads: updateThreads })

      axiosInstance.delete(`/topics/${id}`)
    }
  }
}

export const onChange = (property, value) => {
  return (dispatch, getState) => {
    const { index } = getState().discussion

    if (index === null) {
      dispatch({ type: ON_CHANGE, property, value })
    } else {
      const { threads } = getState().discussion

      const updatedThreads = [
        ...threads.slice(0, index),
        { ...threads[index], [property]: value },
        ...threads.slice(index + 1),
      ]

      dispatch({ type: ON_CHANGE, property: 'threads', value: updatedThreads })
    }
  }
}

export const onSearchReset = (property, value) => {
  return (dispatch, getState) => {
    const { index } = getState().discussion

    if (index === null) {
      dispatch({ type: ON_CHANGE, property, value })
    } else {
      const { threads } = getState().discussion

      const updatedThreads = [
        ...threads.slice(0, index),
        { ...threads[index], [property]: value },
        ...threads.slice(index + 1),
      ]

      dispatch({ type: ON_CHANGE, property: 'threads', value: updatedThreads })
    }
  }
}
